export default __webpack_public_path__ + "static/media/sh_11.20f071a7.png";